import Model from './Model'

export default class Storage extends Model
{
    resource()
    {
        return 'storage'
    }
}
